import { Modal } from '@/components/ui';
import { AboutFacts } from './About';
import { SHORTCUTS } from './shortcuts';

/**
 * F1. What this screen is, the keys that work everywhere, where to get more
 * help, and which build this is.
 */
export function HelpDialog({
  screenLabel,
  onClose,
  onOpenKeyboard,
}: {
  screenLabel: string;
  onClose: () => void;
  onOpenKeyboard: () => void;
}) {
  const anywhere = SHORTCUTS.find((g) => g.group === 'Anywhere')!;
  const lists = SHORTCUTS.find((g) => g.group === 'Lists')!;

  return (
    <Modal title="Help" onClose={onClose} wide>
      <div className="stack helpdialog">
        <div className="helpdialog__head">
          <h2>Help</h2>
          <button type="button" className="btn btn--ghost" onClick={onClose}>
            Close
          </button>
        </div>
        <p>
          You are on <strong>{screenLabel}</strong>. Choose a row in a list to see its details below it. The
          buttons above a list work on the row you chose.
        </p>

        <div className="settingsapp__keys">
          {[anywhere, lists].map((g) => (
            <div key={g.group} className="tablewrap">
              <table className="table">
                <caption className="settingsapp__caption">{g.group}</caption>
                <tbody>
                  {g.rows.map(([keys, does]) => (
                    <tr key={keys}>
                      <td className="settingsapp__key">
                        <kbd>{keys}</kbd>
                      </td>
                      <td>{does}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
        <p>
          <button type="button" className="linkbutton" onClick={onOpenKeyboard}>
            See all keyboard keys
          </button>
        </p>

        <h3>Need more help?</h3>
        <p className="muted">
          Ask your administrator. Tell them the screen name above and what you were trying to do. The details
          below help them find the problem.
        </p>

        <h3>About</h3>
        <AboutFacts />
      </div>
    </Modal>
  );
}
